import styled, { css, useTheme } from 'styled-components';
import {
  BomRequestType,
  ItemBomEssType,
  ItemBomResponseEssType,
  ProductItem,
} from '../../../../api/apiConfig';
import ModalBase from '../ModalBase';
import { BiSolidLeftArrow, BiSolidRightArrow, BiX } from 'react-icons/bi';
import { useEffect, useState, useRef } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { convertNumberStringToNumber } from '../../../../function/replaceString';

export const BomEditModal = ({
  item,
  itemList,
  onClose,
  onSave,
}: {
  item: ItemBomResponseEssType | null;
  itemList: ProductItem[];
  onClose: () => void;
  onSave: (item: BomRequestType) => void;
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(-1); //선택된 항목의 인덱스를 추적하기 위한 상태 변수

  //250212치영추가
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  // 키보드 이벤트 핸들링 함수 추가
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const filteredItems = itemList.filter((item) =>
      item.PROD_DES.includes(searchTerm ?? '')
    );

    if (!filteredItems.length) return; // 필터링된 항목이 없으면 키 입력 처리를 중단

    //아래 방향키
    if (e.key === 'ArrowDown') {
      setSelectedIndex((prev) => (prev + 1) % filteredItems.length); // 아래 방향키: 마지막 항목에서 첫 번째로 순환
      // scrollToItem(selectedIndex + 1, filteredItems.length); // 자동 스크롤 추가
      //위 방향키
    } else if (e.key === 'ArrowUp') {
      setSelectedIndex((prev) =>
        prev <= 0 ? filteredItems.length - 1 : prev - 1
      ); //위 방향키: 첫 번째 항목에서 마지막 항목으로 순환
      // scrollToItem(selectedIndex - 1, filteredItems.length); // 자동 스크롤 추가
      //선택된 항목이 있고 엔터를 눌렀을경우
    } else if (e.key === 'Enter' && selectedIndex >= 0) {
      onClickNewItem(filteredItems[selectedIndex]); //Enter 키로 선택된 항목 추가
      setSelectedIndex(-1); // 선택 초기화
      setSearchTerm(''); // 검색어 초기화
      //ESC를 눌렀을경우
    } else if (e.key === 'Escape') {
      setSelectedIndex(-1); // Esc 키로 선택 초기화
      setSearchTerm('');
    }
  };

  //250212치영 추가
  useEffect(() => {
    if (
      selectedIndex >= 0 &&
      selectedIndex < itemRefs.current.length &&
      itemRefs.current[selectedIndex]
    ) {
      itemRefs.current[selectedIndex]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [selectedIndex]);

  const theme = useTheme();

  const [producedItem, setProducedItem] = useState<ItemBomEssType | null>(null);

  const [searchTerm, setSearchTerm] = useState<string | null>(null);

  const [newBomTargetItem, setNewBomTargetItem] =
    useState<ItemBomEssType | null>(null);

  const [boms, setBoms] = useState<ItemBomEssType[]>([]);

  useEffect(() => {
    if (item && item.producedItem) setProducedItem(item.producedItem);
    if (item && item.consumedItems) {
      setBoms(item.consumedItems);
    }
  }, [item]);

  function saveHandler() {
    if (!producedItem) return;
    if (
      boms.find(
        (bom) =>
          bom.consumedQty && convertNumberStringToNumber(bom.consumedQty) < 1
      )
    )
      return;
    const requestDto: BomRequestType = {
      producedItemId: producedItem.itemId,
      consumedItems: boms.map((bom) => ({
        consumedItemId: bom.itemId,
        consumedQuantity: convertNumberStringToNumber(bom.consumedQty!),
      })),
    };
    onSave(requestDto);
    onClose();
  }

  function deleteHandler(itemId: number) {
    setBoms((prev) => prev.filter((bom) => bom.itemId !== itemId));
  }

  function onClickNewItem(item: ProductItem) {
    const newBomTarget: ItemBomEssType = {
      itemDes: item.PROD_DES,
      sizeDes: item.SIZE_DES,
      itemId: item.id,
      consumedQty: 0,
    };
    setBoms((prev) => [...prev, newBomTarget]);
    // setNewBomTargetItem(newBomTarget);

    setSearchTerm(null);
  }

  function consumedQtyChangeHandler(
    targetIndex: number,
    type: 'decrease' | 'increase' | 'none',
    value?: number | string
  ) {
    setBoms((prev) =>
      prev.map((bom, index) =>
        index === targetIndex
          ? {
              ...bom,
              consumedQty:
                value !== undefined
                  ? value
                  : type === 'decrease'
                  ? convertNumberStringToNumber(bom.consumedQty!) - 1
                  : convertNumberStringToNumber(bom.consumedQty!) + 1,
            }
          : bom
      )
    );
  }

  if (!producedItem) return;

  return (
    <ModalBase>
      <Container>
        <ContainerHeader>
          <BiX
            color={'white'}
            size={40}
            style={{ cursor: 'pointer' }}
            onClick={onClose}
          />
        </ContainerHeader>
        <ContainerBody>
          <Header>생산품 정보</Header>
          <Body>
            <div className='row'>
              <h4 className='row-label'>품목명</h4>
              <h4 className='row-value'>{producedItem.itemDes}</h4>
            </div>
            <div className='row'>
              <h4 className='row-label'>규격명</h4>
              <h4 className='row-value'>{producedItem.sizeDes}</h4>
            </div>
            {/* <div className='row'>
              <div className='row-label'>배송지 주소</div>
              <div className='row-value'>{item?.receiverAddress}</div>
            </div>
            <div className='row'>
              <div className='row-label'>주문 특이사항</div>
              <div className='row-value'>{item?.deliveryRemarks}</div>
            </div> */}
          </Body>
          <Header>소모품 정보</Header>
          <Body>
            {boms.map((bom, index) => (
              <div className='row'>
                <div className='row-button'>
                  <FiTrash2
                    color={theme.colors.red}
                    onClick={() => deleteHandler(bom.itemId)}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <div className='row-prod'>
                  <h4>{bom.itemDes}</h4>
                  <h4>/</h4>
                  <h4>{bom.sizeDes}</h4>
                </div>
                <div className='flex-center'>
                  <div
                    style={{ flex: 1, textAlign: 'start', cursor: 'pointer' }}
                    onClick={() =>
                      convertNumberStringToNumber(bom.consumedQty!) >= 1 &&
                      consumedQtyChangeHandler(index, 'decrease')
                    }
                  >
                    <BiSolidLeftArrow />
                  </div>
                  <input
                    value={bom.consumedQty}
                    onChange={(e) => {
                      let value = e.target.value.trim();

                      // 숫자와 소수점만 허용하고, 소수점은 한 번만 입력 가능
                      value = value.replace(/[^0-9.]/g, ''); // 숫자와 소수점 외 문자 제거
                      if ((value.match(/\./g) || []).length > 1) {
                        value = value.replace(/\.(?=.*\.)/, ''); // 소수점이 2개 이상이면 첫 번째 소수점 이후 제거
                      }

                      // 소수점 2자리까지만 허용
                      const [integer, decimal] = value.split('.');
                      if (decimal && decimal.length > 2) {
                        value = `${integer}.${decimal.slice(0, 2)}`; // 소수점 2자리까지 자르기
                      }

                      // 앞의 '0' 제거 (소수점이 포함되었을 경우 처리)
                      value = value.replace(/^0+(?=\d)/, '');

                      // 빈 값이면 0으로 설정
                      if (value === '' || value === null) {
                        consumedQtyChangeHandler(index, 'none', 0);
                      } else {
                        consumedQtyChangeHandler(index, 'none', value);
                      }
                    }}
                    type='text'
                    style={{ width: '40px', textAlign: 'center' }}
                  />
                  <div
                    style={{ flex: 1, textAlign: 'end', cursor: 'pointer' }}
                    onClick={() => consumedQtyChangeHandler(index, 'increase')}
                  >
                    <BiSolidRightArrow />
                  </div>
                </div>
              </div>
            ))}
            <AddContainer>
              <SearchContainer>
                {newBomTargetItem ? (
                  <h4>{newBomTargetItem.itemDes}</h4>
                ) : (
                  <input
                    value={searchTerm || ''}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyDown} // 키보드 입력 이벤트 추가
                  />
                )}
                {searchTerm?.trim() !== '' && searchTerm !== null && (
                  <div
                    className='search-result-list' // 자동 스크롤 대상 클래스 추가
                    style={{
                      position: 'absolute',
                      minHeight: '0px',
                      maxHeight: '250px',
                      overflowY: 'scroll',
                      top: 22,
                      backgroundColor: 'white',
                      padding: '10px',
                      boxSizing: 'border-box',
                    }}
                  >
                    {itemList
                      .filter((item) => item.PROD_DES.includes(searchTerm))
                      .map((item, index) => {
                        const selectable = !boms.find(
                          (bom) => bom.itemId === item.id
                        );
                        return (
                          <OptionalH4
                            ref={(el) => (itemRefs.current[index] = el)} // ref 추가 - 250212치영추가
                            selectable={selectable}
                            key={item.id}
                            onClick={() => selectable && onClickNewItem(item)}
                            style={{
                              backgroundColor:
                                selectedIndex === index
                                  ? '#ddd'
                                  : 'transparent', //선택된 항목의 배경색을 변경
                            }}
                          >
                            {item.PROD_DES}
                          </OptionalH4>
                        );
                      })}
                  </div>
                )}
              </SearchContainer>
              <AddButton className='flex-center'>추가하기</AddButton>
            </AddContainer>
          </Body>
          {/* <Body>
            {item?.subRows?.map((prod) => (
              <div className='row'>
                <div className='row-value'>
                  {prod.PROD_DES}
                  {prod.SIZE_DES ? ` - ${prod.SIZE_DES}` : ''}
                </div>
                <div className='row-value'>{prod.QTY}개</div>
              </div>
            ))}
          </Body> */}
          <ButtonSection>
            <Button>
              <h4 onClick={() => saveHandler()}>저장</h4>
            </Button>
          </ButtonSection>
        </ContainerBody>
      </Container>
    </ModalBase>
  );
};

const Container = styled.div`
  border-radius: 15px;
  /* overflow: hidden; */
  position: relative;
  width: 600px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  h1,
  h2,
  h3,
  h4 {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const ContainerHeader = styled.div`
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 5px;
  background-color: ${({ theme }) => theme.colors.softBlack};
`;

const ContainerBody = styled.div`
  padding: 0px 15px 15px 15px;
  background-color: ${({ theme }) => theme.colors.lightGray};
`;

const Header = styled.div`
  font-size: ${({ theme }) => theme.fontsize[20]};
  height: 50px;
  align-content: center;
`;

const AddContainer = styled.div`
  display: flex;
  top: 0;
  height: 40px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
const AddButton = styled.h4`
  flex: 0 0 15%;
`;

const SearchContainer = styled.div`
  bottom: 0;
  display: flex;
  position: relative;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-direction: column;
  flex: 0 0 80%;
`;

const ButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 10px;
`;

const Button = styled.div`
  background-color: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  align-content: center;
  text-align: center;
  padding: 5px;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.blue_hover};
  }
`;

const OptionalH4 = styled.h4<{ selectable: boolean }>`
  ${({ selectable }) =>
    selectable
      ? css`
          &:hover {
            cursor: pointer;
            background-color: ${({ theme }) => theme.colors.white_hover};
          }
        `
      : css`
          background-color: ${({ theme }) => theme.colors.whiteGray};
        `}
`;

const Body = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontsize[16]};
  padding: 0px 15px;

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 40px;
  }
  .row-button {
    flex: 0 0 10%;
  }
  .row-prod {
    flex: 1 0 70%;
    display: flex;
    gap: 15px;
  }

  .row-qty {
    flex: 0 0 20%;
  }
`;
